import { registerAction } from '../../Action'
import { workflowActions } from '../workflowActions'

const createResponse = registerAction(workflowActions.CREATE_RESPONSE, {
  reducer: null,
})

export default createResponse
